<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_164" data-name="Group 164" transform="translate(-315.885 -1130.68)">
    <g id="Group_322" data-name="Group 322">
      <circle id="Ellipse_116" data-name="Ellipse 116" cx="35.201" cy="35.201" r="35.201" transform="translate(315.885 1130.68)" fill="#fff"/>
      <g id="Group_163" data-name="Group 163">
        <g id="Group_150" data-name="Group 150">
          <circle id="Ellipse_117" data-name="Ellipse 117" cx="4.065" cy="4.065" r="4.065" transform="translate(363.868 1175.156)" fill="#1a1818"/>
        </g>
        <g id="Group_151" data-name="Group 151">
          <path id="Path_263" data-name="Path 263" d="M368.525,1179.936h-1a16.473,16.473,0,1,0-32.945,0h-1a17.473,17.473,0,1,1,34.945,0Z" fill="#1a1818"/>
        </g>
        <g id="Group_152" data-name="Group 152">
          <path id="Path_264" data-name="Path 264" d="M379.21,1173.464h-1a27.157,27.157,0,0,0-54.314,0h-1a28.157,28.157,0,0,1,56.314,0Z" fill="#1a1818"/>
        </g>
        <g id="Group_153" data-name="Group 153">
          <circle id="Ellipse_118" data-name="Ellipse 118" cx="4.065" cy="4.065" r="4.065" transform="translate(346.988 1158.818)" fill="#1a1818"/>
        </g>
        <g id="Group_154" data-name="Group 154">
          <circle id="Ellipse_119" data-name="Ellipse 119" cx="4.065" cy="4.065" r="4.065" transform="translate(341.786 1142.611)" fill="#1a1818"/>
        </g>
        <g id="Group_155" data-name="Group 155">
          <circle id="Ellipse_120" data-name="Ellipse 120" cx="4.065" cy="4.065" r="4.065" transform="translate(328.276 1149.45)" fill="#1a1818"/>
        </g>
        <g id="Group_156" data-name="Group 156">
          <circle id="Ellipse_121" data-name="Ellipse 121" cx="4.065" cy="4.065" r="4.065" transform="translate(330.174 1175.156)" fill="#1a1818"/>
        </g>
        <g id="Group_157" data-name="Group 157">
          <circle id="Ellipse_122" data-name="Ellipse 122" cx="4.065" cy="4.065" r="4.065" transform="translate(358.686 1163.775)" fill="#1a1818"/>
        </g>
        <g id="Group_158" data-name="Group 158">
          <circle id="Ellipse_123" data-name="Ellipse 123" cx="4.065" cy="4.065" r="4.065" transform="translate(353.075 1142.611)" fill="#1a1818"/>
        </g>
        <g id="Group_159" data-name="Group 159">
          <circle id="Ellipse_124" data-name="Ellipse 124" cx="4.065" cy="4.065" r="4.065" transform="translate(366.697 1149.45)" fill="#1a1818"/>
        </g>
        <g id="Group_160" data-name="Group 160">
          <circle id="Ellipse_125" data-name="Ellipse 125" cx="4.065" cy="4.065" r="4.065" transform="translate(322.043 1158.818)" fill="#1a1818"/>
        </g>
        <g id="Group_161" data-name="Group 161">
          <circle id="Ellipse_126" data-name="Ellipse 126" cx="4.065" cy="4.065" r="4.065" transform="translate(371.999 1158.897)" fill="#1a1818"/>
        </g>
        <g id="Group_162" data-name="Group 162">
          <circle id="Ellipse_127" data-name="Ellipse 127" cx="4.065" cy="4.065" r="4.065" transform="translate(335.289 1163.775)" fill="#1a1818"/>
        </g>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_03_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_03_01.vue